var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":_vm.$t('Recommendations.importCatalog'),"primary-action":{
    label: _vm.$t('Import'),
    onAction: _vm.upload,
    disabled: !_vm.files.length || _vm.isUploading
  },"secondary-actions":[
    {
      label: _vm.$t('Cancel'),
      onAction: function () { return _vm.$emit('close'); }
    }
  ],"visible":_vm.visible,"loading":_vm.isUploading}},[_c('FileInput',{attrs:{"label":_vm.$t('Recommendations.catalogFile'),"help-text":_vm.$t('Recommendations.importFileHelpText'),"max-bytes":50 * 1000 * 1000},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }